<template>
	<div class="chat_wrapper">
		<!-- 모달 : 개인정보 수정 start -->
		<div
			id="modal_person_info"
			class="chat_modal full1"
			style="display: block; position: fixed;"
		>
			<div class="chat_modal_in">
				<div class="chat_modal_head">
					<div class="primary_c">
						<strong>개인정보 수정</strong>
					</div>
					<button class="fas fa-times" @click="close">
						<span class="bg_clip">닫기</span>
					</button>
				</div>

				<!-- 내용 start -->
				<div class="chat_modal_cont overflow_auto">
					<ul class="form_set">
						<li>
							<label for="person_info01" class="type_text">이름</label
							><input
								id="person_info01"
								ref="mbrNm"
								v-model="userData.mbrNm"
								type="text"
								class="chat_form_gray"
								readonly
							/>
						</li>
						<li>
							<label for="person_info02" class="type_text">아이디</label
							><input
								id="person_info02"
								ref="mbrId"
								v-model="userData.mbrId"
								type="text"
								class="chat_form_gray"
								readonly
							/>
						</li>
						<li>
							<label for="person_info03" class="type_text">이메일</label
							><input
								id="person_info03"
								ref="email"
								v-model="userData.email"
								type="text"
								class="chat_form_gray"
							/>
						</li>
						<li>
							<label for="person_info04" class="type_text"
								>비밀번호 <span class="text_small red">*</span> </label
							><input
								id="person_info04"
								ref="pw"
								v-model="userData.pw"
								type="password"
								class="chat_form_gray"
							/><button class="btn small blue_bd" @click="onClickPwEdit">
								비밀번호 변경
							</button>
						</li>
						<li>
							<label for="person_info05" class="type_text">가입일</label
							><input
								id="person_info05"
								v-model="userData.regDt"
								type="text"
								class="chat_form_gray"
								readonly
							/>
						</li>
						<li>
							<label for="person_info06" class="type_text">최종수정일</label
							><input
								id="person_info06"
								v-model="userData.modDt"
								type="text"
								class="chat_form_gray"
								readonly
							/>
						</li>
					</ul>
				</div>
				<!--// 내용 end -->

				<div class="chat_modal_foot">
					<ul class="bot_btnset horizontal align_center half">
						<li>
							<button class="btn medium primary_c_bd" @click="close">
								취소
							</button>
						</li>
						<!-- 닫기 .btn_modal_close 추가 -->
						<li>
							<button class="btn medium primary_c" @click="saveData">
								확인
							</button>
						</li>
					</ul>
				</div>
			</div>
		</div>
		<!--// 모달 : 개인정보 수정 end -->
	</div>
</template>

<script>
import PwEdit from './PwEdit';
import UtilsCrypto from '../../api/crypto';
import storage from '../../api/storage';
import config from '../../config/config.json';

export default {
	props: {
		userId: {
			type: String,
			default: null,
			required: false,
		},
		id: {
			type: String,
			default: null,
			required: false,
		},
		type: {
			type: String,
			default: null,
			required: false,
		},
	},
	data() {
		return {
			userData: {
				mbrId: '',
				mbrNm: '',
				pw: '',
				email: '',
				role: '',
				regDt: '',
				modDt: '',
			},
			// pwCheck: '',
			// pwCheckFail: false
		};
	},
	mounted() {
		this.fetchData();
		window.addEventListener('resize', this.modalStyleSetting);
		this.modalStyleSetting();
	},
	methods: {
		fetchData() {
			this.$axios
				.get(config.MBR_REST_API_PATH + `/mem/${this.id}`)
				.then(response => {
					this.userData = response.data;
				})
				.catch(error => {
					console.log(error);
				});
		},
		onClickPwEdit() {
			this.$modal.show(
				PwEdit,
				{
					id: this.id,
				},
				{
					clickToClose: false,
					height: 'auto',
				},
			);
		},
		saveData() {
			const emailRegex = /^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*.[a-zA-Z]{2,3}$/i;
			if (this.userData.email && !emailRegex.exec(this.userData.email)) {
				alert('이메일 형식이 올바르지 않습니다.');
				this.userData.email = '';
				this.$refs.email.focus();
				return;
			}
			if (!this.userData.pw) {
				alert('비밀번호 항목은 필수 항목입니다.');
				this.$refs.pw.focus();
				return;
			}

			this.userData.pw = UtilsCrypto.cryptoAesEncrypt(this.userData.pw);

			this.$axios
				.put(config.MBR_REST_API_PATH + `/mem/mod`, this.userData, {
					headers: { 'Content-Type': 'application/json' },
				})
				.then(response => {
					const result = response.data;

					if (result === 'success') {
						alert('회원 정보 수정이 완료되었습니다.');
						if (this.type === 'user' || this.userId === this.userData.mbrId) {
							this.userData.pw = '';
							storage.getStorage().setUserData(this.userData);
						}
						this.close();
					} else if (result === 'incorrect') {
						alert('비밀번호를 다시 확인해주세요.');
						this.userData.pw = '';
						this.$refs.pw.focus();
					} else {
						alert('회원 정보 수정을 실패하였습니다.');
						this.close();
					}
				});
		},
		close() {
			this.$emit('close');
		},
		modalStyleSetting() {
			const modal = document.getElementById('modal_person_info');

			if (modal.classList.contains('flexible')) {
				const browser_height = window.innerHeight - 200;
				modal
					.getElementsByClassName('chat_modal_cont')[0]
					.setAttribute('style', 'max-height: ' + browser_height + 'px');

				const chat_modal_in = modal.getElementsByClassName('chat_modal_in')[0];
				const modal_height =
					(window.innerHeight - chat_modal_in.clientHeight) / 2;
				const modal_width = (window.innerWidth - chat_modal_in.clientWidth) / 2;
				chat_modal_in.setAttribute(
					'style',
					'margin-top: ' +
						modal_height +
						'px; margin-left: ' +
						modal_width +
						'px;',
				);
			} else if (modal.classList.contains('slide')) {
				const browser_height = window.innerHeight - 150;
				modal
					.getElementsByClassName('chat_modal_cont')[0]
					.setAttribute('style', 'max-height: ' + browser_height + 'px');

				const chat_modal_in = modal.getElementsByClassName('chat_modal_in')[0];
				chat_modal_in.setAttribute('style', 'bottom: 0');
			}
		},
	},
};
</script>



// WEBPACK FOOTER //
// src/components/member/MemberEdit.vue